import { useState } from 'react';
import Footer from '../../components/footer/Footer';
import Menu from '../../components/menu/menu';
import classes from './contactUs.module.scss';
import { CiLocationOn, CiMail } from "react-icons/ci";
import { FiPhone } from "react-icons/fi";
import { toast, ToastContainer } from 'react-toastify';


export default function ContactUs() {
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/mailing/ContactUs`;

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault(); // Prevent default form submission  

        const requestBody = {
            name,
            email,
            message,
        };

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });

            const responseData = await response.json();

            if (!responseData.failed) {
                toast.success("Your message has been sent, someone from our team will contact you soon.");
                setName('');
                setEmail('');
                setMessage('');
            } else {
                toast.error("An unexpected error occurred. Please try again later.");
            }
        } catch (error) {
            toast.error("Failed to send message. Please check your network.");
        }
    };


    return (
        <div className={classes.module}>
            <ToastContainer style={{zIndex: 99999}} className={classes.toast} position="bottom-center" autoClose={5000} hideProgressBar={true} closeOnClick pauseOnHover />

            <div className={classes.header}>
                <Menu />
            </div>
            <div className={classes.content}>
                <div className={classes.title}>
                    <h1>GET IN TOUCH</h1>
                    <img src="/images/triangle.svg" />
                </div>
                <div className={classes.contact}>
                    <div className={classes.info}>
                        <div className={classes.infoItem}>
                            <CiLocationOn size={30} />
                            <span>
                                3823 Henning Drive, unit 113 <br />
                                Burnaby, BC, V5C 6P3
                            </span>
                        </div>
                        <div className={classes.infoItem}>
                            <CiMail size={25} />
                            <span>
                                info@implantgenius.com
                            </span>
                        </div>
                        <div className={classes.infoItem}>
                            <FiPhone size={25} />
                            <span>
                                604-630-8811
                            </span>
                        </div>
                        <div className={classes.map}>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2603.5786780651274!2d-123.02388932322555!3d49.26543117197532!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5486772a0d166f85%3A0xa1e7739073c789ae!2s3823%20Henning%20Dr%20%23113%2C%20Burnaby%2C%20BC%20V5C%206P3!5e0!3m2!1sen!2sca!4v1742194201270!5m2!1sen!2sca"
                                height="250"
                                style={{ border: 0 }}
                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Google Map Location"
                            ></iframe>
                        </div>
                    </div>
                    <div className={classes.mailbox}>
                        <span>Leave us a message</span>
                        <form onSubmit={handleSubmit}>
                            <input
                                type='text'
                                name='name'
                                title='Name'
                                maxLength={50}
                                placeholder='Name'
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                            <input
                                type='email'
                                name='email'
                                title='Email'
                                maxLength={100}
                                placeholder='Email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <textarea
                                name='message'
                                title='Message'
                                maxLength={5000}
                                placeholder='Write your message here'
                                className={classes.message}
                                rows={3}
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                required
                            />
                            <button type="submit">Send</button>
                        </form>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}
